import { render, staticRenderFns } from "./index.vue?vue&type=template&id=48eb4483&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=48eb4483&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eb4483",
  null
  
)

export default component.exports